export default "__VITE_ASSET__fOSzIQjU__"